var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"topsBox",staticClass:"tip-box"},[_c('p',[_vm._v(_vm._s(_vm.$t('敬请期待…')))])])}
var staticRenderFns = []

export { render, staticRenderFns }